/**
 *
 * @export
 * @interface UpdateTenantSetting
 */
export interface UpdateTenantSetting {
  /**
   *
   * @type {string}
   * @memberof UpdateTenantSetting
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof UpdateTenantSetting
   */
  credentialsId: string
  /**
   *
   * @type {boolean}
   * @memberof UpdateTenantSetting
   */
  enabled?: boolean
}

/**
 * Check if a given object implements the UpdateTenantSetting interface.
 */
export function instanceOfUpdateTenantSetting(value: object): boolean {
  if (!('name' in value)) {return false}
  if (!('credentialsId' in value)) {return false}
  return true
}

export function UpdateTenantSettingFromJSON(json: any): UpdateTenantSetting {
  return UpdateTenantSettingFromJSONTyped(json, false)
}

export function UpdateTenantSettingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateTenantSetting {
  if (json == null) {
    return json
  }
  return {
    name: json.name,
    credentialsId: json.credentials_id,
    enabled: json.enabled == null ? undefined : json.enabled
  }
}

export function UpdateTenantSettingToJSON(
  value?: UpdateTenantSetting | null
): any {
  if (value == null) {
    return value
  }
  return {
    name: value.name,
    credentials_id: value.credentialsId,
    enabled: value.enabled
  }
}
